const pickFirstDefined = (...values) => values.find((value) => value !== undefined && value !== null && value !== '');

export default class DadataAddress {
  constructor(response = {}) {
    const rawData = response?.data || {};

    this.response = response;

    this.address = pickFirstDefined(response.address, response.value, response.name, '');
    this.value = this.address;
    this.name = pickFirstDefined(response.name, this.address, '');
    this.unrestricted_value = pickFirstDefined(response.unrestricted_value, this.address, '');
    this.id = pickFirstDefined(response.id, this.unrestricted_value, this.address, null);

    this.lat = pickFirstDefined(response.lat, rawData.geo_lat, null);
    this.lon = pickFirstDefined(response.lon, rawData.geo_lon, null);
    this.fias_id = pickFirstDefined(response.fias_id, rawData.fias_id, null);
    this.region_fias_id = pickFirstDefined(response.region_fias_id, rawData.region_fias_id, null);
    this.kladr_id = pickFirstDefined(response.kladr_id, rawData.kladr_id, null);
    this.region_kladr_id = pickFirstDefined(response.region_kladr_id, rawData.region_kladr_id, null);
    this.area_fias_id = pickFirstDefined(response.area_fias_id, rawData.area_fias_id, null);
    this.city_fias_id = pickFirstDefined(response.city_fias_id, rawData.city_fias_id, null);

    this.data = {
      ...rawData,
      geo_lat: pickFirstDefined(rawData.geo_lat, this.lat, null),
      geo_lon: pickFirstDefined(rawData.geo_lon, this.lon, null),
      fias_id: pickFirstDefined(rawData.fias_id, this.fias_id, null),
      region_fias_id: pickFirstDefined(rawData.region_fias_id, this.region_fias_id, null),
      kladr_id: pickFirstDefined(rawData.kladr_id, this.kladr_id, null),
      region_kladr_id: pickFirstDefined(rawData.region_kladr_id, this.region_kladr_id, null),
      area_fias_id: pickFirstDefined(rawData.area_fias_id, this.area_fias_id, null),
      city_fias_id: pickFirstDefined(rawData.city_fias_id, this.city_fias_id, null),
    };
  }

  static from(value) {
    if (!value) return null;
    if (typeof value === 'string') return new DadataAddress({ address: value, value });
    if (typeof value !== 'object') return null;
    if (value instanceof DadataAddress) return value;
    return new DadataAddress(value);
  }

  toAddressPayload() {
    return {
      address: this.address,
      lat: this.lat,
      lon: this.lon,
      fias_id: this.fias_id,
      region_fias_id: this.region_fias_id,
      kladr_id: this.kladr_id,
      region_kladr_id: this.region_kladr_id,
      area_fias_id: this.area_fias_id,
      city_fias_id: this.city_fias_id,
    };
  }
}
